module.exports = __webpack_public_path__ + "img/thumb-006-04.a029e6cd.png";